import * as React from 'react';
import { useSelector } from 'react-redux';

import { StickyFooter } from '../../components/StickyFooter';

import { SaveReportContainer } from '../SaveReportContainer';
import { getReportState } from '../../selectors/report';
import { EReportStatus } from '../../constants/report';
import { ShareReportContainer } from '../ShareReportContainer';
import { withVisibleInReportStatus } from '../../utils/report';
import { CreateReportContainer } from '../CreateReportContainer';
import { selectDealType, selectIsStickyFooterVisible } from '../../selectors/page';
import { selectAllEstimation } from '../../selectors/estimation';

export const StickyFooterContainer_: React.FC = () => {
  const estimation = useSelector(selectAllEstimation);
  const dealType = useSelector(selectDealType);
  const { reportStatus } = useSelector(getReportState);
  const isStickyFooterVisible = useSelector(selectIsStickyFooterVisible);
  const isNotEstimationData = !estimation[dealType].data && !estimation[dealType].isError;

  if (!isStickyFooterVisible || isNotEstimationData) {
    return null;
  }

  let Component = null;

  switch (reportStatus) {
    case EReportStatus.Default:
      Component = <CreateReportContainer />;
      break;
    case EReportStatus.Preview:
      Component = <SaveReportContainer />;
      break;
    case EReportStatus.Share:
      Component = <ShareReportContainer />;
      break;
  }

  return <StickyFooter>{Component}</StickyFooter>;
};

StickyFooterContainer_.displayName = 'StickyFooterContainer';

export const StickyFooterContainer = withVisibleInReportStatus({
  notIn: [EReportStatus.Finished],
})(StickyFooterContainer_);
